const regionDomamin = [
    { titleSelect: 'Kab. Bekasi', valSelect: '0102' },
    { titleSelect: 'Kab. Purwakarta', valSelect: '0103' },
    { titleSelect: 'Kab. Karawang', valSelect: '0106' },
    { titleSelect: 'Kab. Bogor', valSelect: '0108' },
    { titleSelect: 'Kab. Sukabumi', valSelect: '0109' },
    { titleSelect: 'Kab. Cianjur', valSelect: '0110' },
    { titleSelect: 'Kab. Bandung', valSelect: '0111' },
    { titleSelect: 'Kab. Sumedang', valSelect: '0112' },
    { titleSelect: 'Kab. Tasikmalaya', valSelect: '0113' },
    { titleSelect: 'Kab. Garut', valSelect: '0114' },
    { titleSelect: 'Kab. Ciamis', valSelect: '0115' },
    { titleSelect: 'Kab. Cirebon', valSelect: '0116' },
    { titleSelect: 'Kab. Kuningan', valSelect: '0117' },
    { titleSelect: 'Kab. Indramayu', valSelect: '0118' },
    { titleSelect: 'Kab. Majalengka', valSelect: '0119' },
    { titleSelect: 'Kab. Subang', valSelect: '0121' },
    { titleSelect: 'Kab. Bandung Barat', valSelect: '0122' },
    { titleSelect: 'Kab. Pangandaran', valSelect: '0123' },
    { titleSelect: 'Kota Banjar', valSelect: '0180' },
    { titleSelect: 'Kota Bandung', valSelect: '0191' },
    { titleSelect: 'Kota Bogor', valSelect: '0192' },
    { titleSelect: 'Kota Sukabumi', valSelect: '0193' },
    { titleSelect: 'Kota Cirebon', valSelect: '0194' },
    { titleSelect: 'Kota Tasikmalaya', valSelect: '0195' },
    { titleSelect: 'Kota Cimahi', valSelect: '0196' },
    { titleSelect: 'Kota Depok', valSelect: '0197' },
    { titleSelect: 'Kota Bekasi', valSelect: '0198' },
    { titleSelect: 'Provinsi Banten', valSelect: '0200' },
    { titleSelect: 'Kab. Lebak', valSelect: '0201' },
    { titleSelect: 'Kab. Pandeglang', valSelect: '0202' },
    { titleSelect: 'Kab. Serang', valSelect: '0203' },
    { titleSelect: 'Kab. Tangerang', valSelect: '0204' },
    { titleSelect: 'Kota Cilegon', valSelect: '0291' },
    { titleSelect: 'Kota Tangerang', valSelect: '0292' },
    { titleSelect: 'Kota Serang', valSelect: '0293' },
    { titleSelect: 'Kota Tanggerang Selatan', valSelect: '0294' },
    { titleSelect: 'Provinsi DKI Jakarta Raya', valSelect: '0300' },
    { titleSelect: 'Wil. Kota Jakarta Pusat', valSelect: '0391' },
    { titleSelect: 'Wil. Kota Jakarta Utara', valSelect: '0392' },
    { titleSelect: 'Wil. Kota Jakarta Barat', valSelect: '0393' },
    { titleSelect: 'Wil. Kota Jakarta Selatan', valSelect: '0394' },
    { titleSelect: 'Wil. Kota Jakarta Timur', valSelect: '0395' },
    { titleSelect: 'Wil. Kab. Administrasi Kepulauan Seribu', valSelect: '0396' },
    { titleSelect: 'Daerah Istimewa Yogyakarta', valSelect: '0500' },
    { titleSelect: 'Kab. Bantul', valSelect: '0501' },
    { titleSelect: 'Kab. Sleman', valSelect: '0502' },
    { titleSelect: 'Kab. Gunung Kidul', valSelect: '0503' },
    { titleSelect: 'Kab. Kulon Progo', valSelect: '0504' },
    { titleSelect: 'Kota Yogyakarta', valSelect: '0591' },
    { titleSelect: 'Provinsi Jawa Tengah', valSelect: '0900' },
    { titleSelect: 'Kab. Semarang', valSelect: '0901' },
    { titleSelect: 'Kab. Kendal', valSelect: '0902' },
    { titleSelect: 'Kab. Demak', valSelect: '0903' },
    { titleSelect: 'Kab. Grobogan', valSelect: '0904' },
    { titleSelect: 'Kab. Pekalongan', valSelect: '0905' },
    { titleSelect: 'Kab. Tegal', valSelect: '0906' },
    { titleSelect: 'Kab. Brebes', valSelect: '0907' },
    { titleSelect: 'Kab. Pati', valSelect: '0908' },
    { titleSelect: 'Kab. Kudus', valSelect: '0909' },
    { titleSelect: 'Kab. Pemalang', valSelect: '0910' },
    { titleSelect: 'Kab. Jepara', valSelect: '0911' },
    { titleSelect: 'Kab. Rembang', valSelect: '0912' },
    { titleSelect: 'Kab. Blora', valSelect: '0913' },
    { titleSelect: 'Kab. Banyumas', valSelect: '0914' },
    { titleSelect: 'Kab. Cilacap', valSelect: '0915' },
    { titleSelect: 'Kab. Purbalingga', valSelect: '0916' },
    { titleSelect: 'Kab. Banjarnegara', valSelect: '0917' },
    { titleSelect: 'Kab. Magelang', valSelect: '0918' },
    { titleSelect: 'Kab. Temanggung', valSelect: '0919' },
    { titleSelect: 'Kab. Wonosobo', valSelect: '0920' },
    { titleSelect: 'Kab. Purworejo', valSelect: '0921' },
    { titleSelect: 'Kab. Kebumen', valSelect: '0922' },
    { titleSelect: 'Kab. Klaten', valSelect: '0923' },
    { titleSelect: 'Kab. Boyolali', valSelect: '0924' },
    { titleSelect: 'Kab. Sragen', valSelect: '0925' },
    { titleSelect: 'Kab. Sukoharjo', valSelect: '0926' },
    { titleSelect: 'Kab. Karanganyar', valSelect: '0927' },
    { titleSelect: 'Kab. Wonogiri', valSelect: '0928' },
    { titleSelect: 'Kab. Batang', valSelect: '0929' },
    { titleSelect: 'Kota Semarang', valSelect: '0991' },
    { titleSelect: 'Kota Salatiga', valSelect: '0992' },
    { titleSelect: 'Kota Pekalongan', valSelect: '0993' },
    { titleSelect: 'Kota Tegal', valSelect: '0994' },
    { titleSelect: 'Kota Magelang', valSelect: '0995' },
    { titleSelect: 'Kota Surakarta/Solo', valSelect: '0996' },
    { titleSelect: 'Provinsi Jawa Timur', valSelect: '1200' },
    { titleSelect: 'Kab. Gresik', valSelect: '1201' },
    { titleSelect: 'Kab. Sidoarjo', valSelect: '1202' },
    { titleSelect: 'Kab. Mojokerto', valSelect: '1203' },
    { titleSelect: 'Kab. Jombang', valSelect: '1204' },
    { titleSelect: 'Kab. Sampang', valSelect: '1205' },
    { titleSelect: 'Kab. Pamekasan', valSelect: '1206' },
    { titleSelect: 'Kab. Sumenep', valSelect: '1207' },
    { titleSelect: 'Kab. Bangkalan', valSelect: '1208' },
    { titleSelect: 'Kab. Bondowoso', valSelect: '1209' },
    { titleSelect: 'Kab. Banyuwangi', valSelect: '1211' },
    { titleSelect: 'Kab. Jember', valSelect: '1212' },
    { titleSelect: 'Kab. Malang', valSelect: '1213' },
    { titleSelect: 'Kab. Pasuruan', valSelect: '1214' },
    { titleSelect: 'Kab. Probolinggo', valSelect: '1215' },
    { titleSelect: 'Kab. Lumajang', valSelect: '1216' },
    { titleSelect: 'Kab. Kediri', valSelect: '1217' },
    { titleSelect: 'Kab. Nganjuk', valSelect: '1218' },
    { titleSelect: 'Kab. Tulungagung', valSelect: '1219' },
    { titleSelect: 'Kab. Trenggalek', valSelect: '1220' },
    { titleSelect: 'Kab. Blitar', valSelect: '1221' },
    { titleSelect: 'Kab. Madiun', valSelect: '1222' },
    { titleSelect: 'Kab. Ngawi', valSelect: '1223' },
    { titleSelect: 'Kab. Magetan', valSelect: '1224' },
    { titleSelect: 'Kab. Ponorogo', valSelect: '1225' },
    { titleSelect: 'Kab. Pacitan', valSelect: '1226' },
    { titleSelect: 'Kab. Bojonegoro', valSelect: '1227' },
    { titleSelect: 'Kab. Tuban', valSelect: '1228' },
    { titleSelect: 'Kab. Lamongan', valSelect: '1229' },
    { titleSelect: 'Kab. Situbondo', valSelect: '1230' },
    { titleSelect: 'Kota Batu', valSelect: '1271' },
    { titleSelect: 'Kota Surabaya', valSelect: '1291' },
    { titleSelect: 'Kota Mojokerto', valSelect: '1292' },
    { titleSelect: 'Kota Malang', valSelect: '1293' },
    { titleSelect: 'Kota Pasuruan', valSelect: '1294' },
    { titleSelect: 'Kota Probolinggo', valSelect: '1295' },
    { titleSelect: 'Kota Blitar', valSelect: '1296' },
    { titleSelect: 'Kota Kediri', valSelect: '1297' },
    { titleSelect: 'Kota Madiun', valSelect: '1298' },
    { titleSelect: 'Provinsi Bengkulu', valSelect: '2300' },
    { titleSelect: 'Kab. Bengkulu Selatan', valSelect: '2301' },
    { titleSelect: 'Kab. Bengkulu Utara', valSelect: '2302' },
    { titleSelect: 'Kab. Rejang Lebong', valSelect: '2303' },
    { titleSelect: 'Kab. Lebong', valSelect: '2304' },
    { titleSelect: 'Kab. Kepahiang', valSelect: '2305' },
    { titleSelect: 'Kab. Mukomuko', valSelect: '2306' },
    { titleSelect: 'Kab. Seluma', valSelect: '2307' },
    { titleSelect: 'Kab. Kaur', valSelect: '2308' },
    { titleSelect: 'Kab. Bengkulu Tengah', valSelect: '2309' },
    { titleSelect: 'Kota Bengkulu', valSelect: '2391' },
    { titleSelect: 'Provinsi Jambi', valSelect: '3100' },
    { titleSelect: 'Kab. Batanghari', valSelect: '3101' },
    { titleSelect: 'Kab. Sarolangun', valSelect: '3104' },
    { titleSelect: 'Kab. Kerinci', valSelect: '3105' },
    { titleSelect: 'Kab. Muaro Jambi', valSelect: '3106' },
    { titleSelect: 'Kab. Tanjung Jabung Barat', valSelect: '3107' },
    { titleSelect: 'Kab. Tanjung Jabung Timur', valSelect: '3108' },
    { titleSelect: 'Kab. Tebo', valSelect: '3109' },
    { titleSelect: 'Kab. Merangin', valSelect: '3111' },
    { titleSelect: 'Kab. Bungo', valSelect: '3112' },
    { titleSelect: 'Kota Jambi', valSelect: '3191' },
    { titleSelect: 'Kota Sungai Penuh', valSelect: '3192' },
    { titleSelect: 'Provinsi Nanggroe Aceh Darussalam', valSelect: '3200' },
    { titleSelect: 'Kab. Aceh Besar', valSelect: '3201' },
    { titleSelect: 'Kab. Pidie', valSelect: '3202' },
    { titleSelect: 'Kab. Aceh Utara', valSelect: '3203' },
    { titleSelect: 'Kab. Aceh Timur', valSelect: '3204' },
    { titleSelect: 'Kab. Aceh Selatan', valSelect: '3205' },
    { titleSelect: 'Kab. Aceh Barat', valSelect: '3206' },
    { titleSelect: 'Kab. Aceh Tengah', valSelect: '3207' },
    { titleSelect: 'Kab. Aceh Tenggara', valSelect: '3208' },
    { titleSelect: 'Kab. Aceh Singkil', valSelect: '3209' },
    { titleSelect: 'Kab. Aceh Jeumpa /Bireuen', valSelect: '3210' },
    { titleSelect: 'Kab. Aceh Tamiang', valSelect: '3211' },
    { titleSelect: 'Kab. Gayo Luwes', valSelect: '3212' },
    { titleSelect: 'Kab. Aceh Barat Daya', valSelect: '3213' },
    { titleSelect: 'Kab. Aceh Jaya', valSelect: '3214' },
    { titleSelect: 'Kab. Nagan Raya', valSelect: '3215' },
    { titleSelect: 'Kab. Simeuleu', valSelect: '3216' },
    { titleSelect: 'Kab. Bener Meriah', valSelect: '3217' },
    { titleSelect: 'Kab. Pidie Jaya', valSelect: '3218' },
    { titleSelect: 'Kab. Subulussalam', valSelect: '3219' },
    { titleSelect: 'Kota Banda Aceh', valSelect: '3291' },
    { titleSelect: 'Kota Sabang', valSelect: '3292' },
    { titleSelect: 'Kota Lhokseumawe', valSelect: '3293' },
    { titleSelect: 'Kota Langsa', valSelect: '3294' },
    { titleSelect: 'Provinsi Sumatera Utara', valSelect: '3300' },
    { titleSelect: 'Kab. Deli Serdang', valSelect: '3301' },
    { titleSelect: 'Kab. Langkat', valSelect: '3302' },
    { titleSelect: 'Kab. Karo', valSelect: '3303' },
    { titleSelect: 'Kab. Simalungun', valSelect: '3304' },
    { titleSelect: 'Kab. Labuhan Batu', valSelect: '3305' },
    { titleSelect: 'Kab. Asahan', valSelect: '3306' },
    { titleSelect: 'Kab. Dairi', valSelect: '3307' },
    { titleSelect: 'Kab. Tapanuli Utara', valSelect: '3308' },
    { titleSelect: 'Kab. Tapanuli Tengah', valSelect: '3309' },
    { titleSelect: 'Kab. Tapanuli Selatan', valSelect: '3310' },
    { titleSelect: 'Kab. Nias', valSelect: '3311' },
    { titleSelect: 'Kab. Toba Samosir', valSelect: '3313' },
    { titleSelect: 'Kab. Nias Selatan', valSelect: '3315' },
    { titleSelect: 'Kab. Humbang Hasundutan', valSelect: '3316' },
    { titleSelect: 'Kab. Pakpak Bharat', valSelect: '3317' },
    { titleSelect: 'Kab. Samosir', valSelect: '3318' },
    { titleSelect: 'Kab. Serdang Bedagai', valSelect: '3319' },
    { titleSelect: 'Kab. Batu Bara', valSelect: '3321' },
    { titleSelect: 'Kab. Padang Lawas', valSelect: '3322' },
    { titleSelect: 'Kab. Padang Lawas Utara', valSelect: '3323' },
    { titleSelect: 'Kab. Labuanbatu Selatan', valSelect: '3324' },
    { titleSelect: 'Kab. Labuanbatu Utara', valSelect: '3325' },
    { titleSelect: 'Kab. Nias Barat', valSelect: '3326' },
    { titleSelect: 'Kab. Nias Utara', valSelect: '3327' },
    { titleSelect: 'Kota Tebing Tinggi', valSelect: '3391' },
    { titleSelect: 'Kota Binjai', valSelect: '3392' },
    { titleSelect: 'Kota Pematang Siantar', valSelect: '3393' },
    { titleSelect: 'Kota Tanjung Balai', valSelect: '3394' },
    { titleSelect: 'Kota Sibolga', valSelect: '3395' },
    { titleSelect: 'Kota Medan', valSelect: '3396' },
    { titleSelect: 'Kota Gunung Sitoli', valSelect: '3397' },
    { titleSelect: 'Kota Padang Sidempuan', valSelect: '3399' },
    { titleSelect: 'Provinsi Sumatera Barat', valSelect: '3400' },
    { titleSelect: 'Kab. Agam', valSelect: '3401' },
    { titleSelect: 'Kab. Pasaman', valSelect: '3402' },
    { titleSelect: 'Kab. Limapuluh Kota', valSelect: '3403' },
    { titleSelect: 'Kab. Solok Selatan', valSelect: '3404' },
    { titleSelect: 'Kab. Padang Pariaman', valSelect: '3405' },
    { titleSelect: 'Kab. Pesisir Selatan', valSelect: '3406' },
    { titleSelect: 'Kab. Tanah Datar', valSelect: '3407' },
    { titleSelect: 'Kab. Sawah Lunto/Sijunjung', valSelect: '3408' },
    { titleSelect: 'Kab. Kepulauan Mentawai', valSelect: '3409' },
    { titleSelect: 'Kab. Pasaman Barat', valSelect: '3410' },
    { titleSelect: 'Kab. Dharmasraya', valSelect: '3411' },
    { titleSelect: 'Kab. Solok', valSelect: '3412' },
    { titleSelect: 'Kota Bukittinggi', valSelect: '3491' },
    { titleSelect: 'Kota Padang', valSelect: '3492' },
    { titleSelect: 'Kota Sawahlunto', valSelect: '3493' },
    { titleSelect: 'Kota Padang Panjang', valSelect: '3494' },
    { titleSelect: 'Kota Solok', valSelect: '3495' },
    { titleSelect: 'Kota Payakumbuh', valSelect: '3496' },
    { titleSelect: 'Kota Pariaman', valSelect: '3497' },
    { titleSelect: 'Provinsi Riau', valSelect: '3500' },
    { titleSelect: 'Kab. Kampar', valSelect: '3501' },
    { titleSelect: 'Kab. Bengkalis', valSelect: '3502' },
    { titleSelect: 'Kab. Indragiri Hulu', valSelect: '3504' },
    { titleSelect: 'Kab. Indragiri Hilir', valSelect: '3505' },
    { titleSelect: 'Kab. Rokan Hulu', valSelect: '3508' },
    { titleSelect: 'Kab. Rokan Hilir', valSelect: '3509' },
    { titleSelect: 'Kab. Pelalawan', valSelect: '3510' },
    { titleSelect: 'Kab. Siak', valSelect: '3511' },
    { titleSelect: 'Kab. Kuantan Singingi', valSelect: '3512' },
    { titleSelect: 'Kab. Kepulauan Meranti', valSelect: '3513' },
    { titleSelect: 'Kota Pekanbaru', valSelect: '3591' },
    { titleSelect: 'Kota Dumai', valSelect: '3592' },
    { titleSelect: 'Provinsi Sumatera Selatan', valSelect: '3600' },
    { titleSelect: 'Kab. Musi Banyuasin', valSelect: '3606' },
    { titleSelect: 'Kab. Ogan Komering Ulu', valSelect: '3607' },
    { titleSelect: 'Kab. Lematang Ilir Ogan Tengah (Muara Enim)', valSelect: '3608' },
    { titleSelect: 'Kab. Lahat', valSelect: '3609' },
    { titleSelect: 'Kab. Musi Rawas', valSelect: '3610' },
    { titleSelect: 'Kab. Ogan Komering Ilir', valSelect: '3611' },
    { titleSelect: 'Kab. Banyuasin', valSelect: '3613' },
    { titleSelect: 'Kab. Ogan Komering Ulu Selatan', valSelect: '3614' },
    { titleSelect: 'Kab. Ogan Komering Ulu Timur', valSelect: '3615' },
    { titleSelect: 'Kab. Ogan Ilir', valSelect: '3616' },
    { titleSelect: 'Kab. Empat Lawang', valSelect: '3617' },
    { titleSelect: 'Kab. Musi Rawas Utara', valSelect: '3618' },
    { titleSelect: 'Kab. Penukal Abab Lematang Ilir', valSelect: '3619' },
    { titleSelect: 'Kota Palembang', valSelect: '3691' },
    { titleSelect: 'Kota Lubuklinggau', valSelect: '3693' },
    { titleSelect: 'Kota Prabumulih', valSelect: '3694' },
    { titleSelect: 'Kota Pagar Alam', valSelect: '3697' },
    { titleSelect: 'Provinsi Kep. Bangka Belitung', valSelect: '3700' },
    { titleSelect: 'Kab. Bangka', valSelect: '3701' },
    { titleSelect: 'Kab. Belitung', valSelect: '3702' },
    { titleSelect: 'Kab. Bangka Barat', valSelect: '3703' },
    { titleSelect: 'Kab. Bangka Selatan', valSelect: '3704' },
    { titleSelect: 'Kab. Bangka Tengah', valSelect: '3705' },
    { titleSelect: 'Kab. Belitung Timur', valSelect: '3706' },
    { titleSelect: 'Kota Pangkal Pinang', valSelect: '3707' },
    { titleSelect: 'Provinsi Kep. Riau', valSelect: '3800' },
    { titleSelect: 'Kab. Karimun', valSelect: '3801' },
    { titleSelect: 'Kab. Lingga', valSelect: '3802' },
    { titleSelect: 'Kab. Natuna', valSelect: '3803' },
    { titleSelect: 'Kab. Bintan (d/h Kabupaten Kepulauan Riau)', valSelect: '3804' },
    { titleSelect: 'Kab. Kepulauan Anambas', valSelect: '3805' },
    { titleSelect: 'Kota Tanjung Pinang', valSelect: '3891' },
    { titleSelect: 'Kota Batam', valSelect: '3892' },
    { titleSelect: 'Provinsi Lampung', valSelect: '3900' },
    { titleSelect: 'Kab. Lampung Selatan', valSelect: '3901' },
    { titleSelect: 'Kab. Lampung Tengah', valSelect: '3902' },
    { titleSelect: 'Kab. Lampung Utara', valSelect: '3903' },
    { titleSelect: 'Kab. Lampung Barat', valSelect: '3904' },
    { titleSelect: 'Kab. Tulang Bawang', valSelect: '3905' },
    { titleSelect: 'Kab. Tanggamus', valSelect: '3906' },
    { titleSelect: 'Kab. Lampung Timur', valSelect: '3907' },
    { titleSelect: 'Kab. Way Kanan', valSelect: '3908' },
    { titleSelect: 'Kab. Pesawaran', valSelect: '3909' },
    { titleSelect: 'Kab. Pringsewu', valSelect: '3910' },
    { titleSelect: 'Kab. Tulang Bawang Barat', valSelect: '3911' },
    { titleSelect: 'Kab. Mesuji', valSelect: '3912' },
    { titleSelect: 'Kab. Pesisir Barat', valSelect: '3913' },
    { titleSelect: 'Kota Bandar Lampung', valSelect: '3991' },
    { titleSelect: 'Kota Metro', valSelect: '3992' },
    { titleSelect: 'Provinsi Kalimantan Selatan', valSelect: '5100' },
    { titleSelect: 'Kab. Banjar', valSelect: '5101' },
    { titleSelect: 'Kab. Tanah Laut', valSelect: '5102' },
    { titleSelect: 'Kab. Tapin', valSelect: '5103' },
    { titleSelect: 'Kab. Hulu Sungai Selatan', valSelect: '5104' },
    { titleSelect: 'Kab. Hulu Sungai Tengah', valSelect: '5105' },
    { titleSelect: 'Kab. Hulu Sungai Utara', valSelect: '5106' },
    { titleSelect: 'Kab. Barito Kuala', valSelect: '5107' },
    { titleSelect: 'Kab. Kota Baru', valSelect: '5108' },
    { titleSelect: 'Kab. Tabalong', valSelect: '5109' },
    { titleSelect: 'Kab. Tanah Bumbu', valSelect: '5110' },
    { titleSelect: 'Kab. Balangan', valSelect: '5111' },
    { titleSelect: 'Kota Banjarmasin', valSelect: '5191' },
    { titleSelect: 'Kota Banjarbaru', valSelect: '5192' },
    { titleSelect: 'Provinsi Kalimantan Barat', valSelect: '5300' },
    { titleSelect: 'Kab. Pontianak', valSelect: '5301' },
    { titleSelect: 'Kab. Sambas', valSelect: '5302' },
    { titleSelect: 'Kab. Ketapang', valSelect: '5303' },
    { titleSelect: 'Kab. Sanggau', valSelect: '5304' },
    { titleSelect: 'Kab. Sintang', valSelect: '5305' },
    { titleSelect: 'Kab. Kapuas Hulu', valSelect: '5306' },
    { titleSelect: 'Kab. Bengkayang', valSelect: '5307' },
    { titleSelect: 'Kab. Landak', valSelect: '5308' },
    { titleSelect: 'Kab. Sekadau', valSelect: '5309' },
    { titleSelect: 'Kab. Melawi', valSelect: '5310' },
    { titleSelect: 'Kab. Kayong Utara', valSelect: '5311' },
    { titleSelect: 'Kab. Kubu Raya', valSelect: '5312' },
    { titleSelect: 'Kota Pontianak', valSelect: '5391' },
    { titleSelect: 'Kota Singkawang', valSelect: '5392' },
    { titleSelect: 'Provinsi Kalimantan Timur', valSelect: '5400' },
    { titleSelect: 'Kab. Kutai Kartanegara', valSelect: '5401' },
    { titleSelect: 'Kab. Berau', valSelect: '5402' },
    { titleSelect: 'Kab. Paser', valSelect: '5403' },
    { titleSelect: 'Kab. Bulungan', valSelect: '5404' },
    { titleSelect: 'Kab. Kutai Barat', valSelect: '5405' },
    { titleSelect: 'Kab. Kutai Timur', valSelect: '5406' },
    { titleSelect: 'Kab. Nunukan', valSelect: '5409' },
    { titleSelect: 'Kab. Malinau', valSelect: '5410' },
    { titleSelect: 'Kab. Penajam Paser Utara', valSelect: '5411' },
    { titleSelect: 'Kab. Tana Tidung', valSelect: '5412' },
    { titleSelect: 'kab. Mahakam Ulu', valSelect: '5413' },
    { titleSelect: 'Kota Samarinda', valSelect: '5491' },
    { titleSelect: 'Kota Balikpapan', valSelect: '5492' },
    { titleSelect: 'Kota Tarakan', valSelect: '5493' },
    { titleSelect: 'Kota Bontang', valSelect: '5494' },
    { titleSelect: 'Provinsi Kalimantan Utara', valSelect: '5500' },
    { titleSelect: 'Provinsi Kalimantan Tengah', valSelect: '5800' },
    { titleSelect: 'Kab. Kapuas', valSelect: '5801' },
    { titleSelect: 'Kab. Kotawaringin Barat', valSelect: '5802' },
    { titleSelect: 'Kab. Kotawaringin Timur', valSelect: '5803' },
    { titleSelect: 'Kab. Murung Raya', valSelect: '5804' },
    { titleSelect: 'Kab. Barito Timur', valSelect: '5805' },
    { titleSelect: 'Kab. Barito Selatan', valSelect: '5806' },
    { titleSelect: 'Kab. Gunung Mas', valSelect: '5807' },
    { titleSelect: 'Kab. Barito Utara', valSelect: '5808' },
    { titleSelect: 'Kab. Pulang Pisau', valSelect: '5809' },
    { titleSelect: 'Kab. Seruyan', valSelect: '5810' },
    { titleSelect: 'Kab. Katingan', valSelect: '5811' },
    { titleSelect: 'Kab. Sukamara', valSelect: '5812' },
    { titleSelect: 'Kab. Lamandau', valSelect: '5813' },
    { titleSelect: 'Kota Palangkaraya', valSelect: '5892' },
    { titleSelect: 'Provinsi Sulawesi Tengah', valSelect: '6000' },
    { titleSelect: 'Kab. Donggala', valSelect: '6001' },
    { titleSelect: 'Kab. Poso', valSelect: '6002' },
    { titleSelect: 'Kab. Banggai', valSelect: '6003' },
    { titleSelect: 'Kab. Toli-Toli', valSelect: '6004' },
    { titleSelect: 'Kab. Banggai Kepulauan', valSelect: '6005' },
    { titleSelect: 'Kab. Morowali', valSelect: '6006' },
    { titleSelect: 'Kab. Buol', valSelect: '6007' },
    { titleSelect: 'Kab. Tojo Una-Una', valSelect: '6008' },
    { titleSelect: 'Kab. Parigi Moutong', valSelect: '6009' },
    { titleSelect: 'Kab. Sig', valSelect: '6010' },
    { titleSelect: 'Kab. Banggai Laut', valSelect: '6011' },
    { titleSelect: 'Kab. Morowali Utara', valSelect: '6012' },
    { titleSelect: 'Kota Palu', valSelect: '6091' },
    { titleSelect: 'Provinsi Sulawesi Selatan', valSelect: '6100' },
    { titleSelect: 'Kab. Pinrang', valSelect: '6101' },
    { titleSelect: 'Kab. Gowa', valSelect: '6102' },
    { titleSelect: 'Kab. Wajo', valSelect: '6103'},
    { titleSelect: 'Kab. Bone', valSelect: '6105' },
    { titleSelect: 'Kab. Tana Toraja', valSelect: '6106' },
    { titleSelect: 'Kab. Maros', valSelect: '6107' },
    { titleSelect: 'Kab. Luwu', valSelect: '6109' },
    { titleSelect: 'Kab. Sinjai', valSelect: '6110' },
    { titleSelect: 'Kab. Bulukumba', valSelect: '6111' },
    { titleSelect: 'Kab. Bantaeng', valSelect: '6112' },
    { titleSelect: 'Kab. Jeneponto', valSelect: '6113' },
    { titleSelect: 'Kab. Kepulauan Selayar', valSelect: '6114' },
    { titleSelect: 'Kab. Takalar', valSelect: '6115' },
    { titleSelect: 'Kab. Barru', valSelect: '6116' },
    { titleSelect: 'Kab. Sidenreng Rappang', valSelect: '6117' },
    { titleSelect: 'Kab. Pangkajene Kepulauan', valSelect: '6118' },
    { titleSelect: 'Kab. Soppeng (d/h Watansoppeng)', valSelect: '6119' },
    { titleSelect: 'Kab. Enrekang', valSelect: '6121' },
    { titleSelect: 'Kab. Luwu Timur (d/h Luwu Selatan)', valSelect: '6122' },
    { titleSelect: 'Kab. Luwu Utara', valSelect: '6124' },
    { titleSelect: 'Kab. Toraja Utara', valSelect: '6125' },
    { titleSelect: 'Kota Makassar', valSelect: '6191' },
    { titleSelect: 'Kota Pare-Pare', valSelect: '6192' },
    { titleSelect: 'Kota Palopo', valSelect: '6193' },
    { titleSelect: 'Provinsi Sulawesi Utara', valSelect: '6200' },
    { titleSelect: 'Kab. Minahasa', valSelect: '6202' },
    { titleSelect: 'Kab. Bolaang Mongondow', valSelect: '6203' },
    { titleSelect: 'Kab. Kepulauan Sangihe', valSelect: '6204' },
    { titleSelect: 'Kab. kepulauan Talaud', valSelect: '6205' },
    { titleSelect: 'Kab. Minahasa Selatan', valSelect: '6206' },
    { titleSelect: 'Kab. Minahasa Utara', valSelect: '6207' },
    { titleSelect: 'Kab. Minahasa Tenggara', valSelect: '6209' },
    { titleSelect: 'Kab. Bolaang Mongondow Utara', valSelect: '6210' },
    { titleSelect: 'Kab. Kepulauan Sitaro', valSelect: '6211' },
    { titleSelect: 'Kab. Bolaang Mongondow Selatan', valSelect: '6212' },
    { titleSelect: 'Kab. Bolaang Mongondow Timur', valSelect: '6213' },
    { titleSelect: 'Kota Manado', valSelect: '6291' },
    { titleSelect: 'Kota Kotamobagu', valSelect: '6292' },
    { titleSelect: 'Kota Bitung', valSelect: '6293' },
    { titleSelect: 'Kota Tomohon', valSelect: '6294' },
    { titleSelect: 'Provinsi Gorontalo', valSelect: '6300' },
    { titleSelect: 'Kab. Gorontalo', valSelect: '6301' },
    { titleSelect: 'Kab. Bualemo', valSelect: '6302' },
    { titleSelect: 'Kab. Bonebolango', valSelect: '6303' },
    { titleSelect: 'Kab. Pohuwato', valSelect: '6304' },
    { titleSelect: 'Kab. Gorontalo Utara', valSelect: '6305' },
    { titleSelect: 'Kota Gorontalo', valSelect: '6391' },
    { titleSelect: 'Provinsi Sulawesi Barat', valSelect: '6400' },
    { titleSelect: 'Kab. Polewali Mandar', valSelect: '6401' },
    { titleSelect: 'Kab. Majene', valSelect: '6402' },
    { titleSelect: 'Kab. Mamasa', valSelect: '6403' },
    { titleSelect: 'Kab. Mamuju Utara', valSelect: '6404' },
    { titleSelect: 'Kab. Mamuju Tengah', valSelect: '6405' },
    { titleSelect: 'Kab. Mamuju', valSelect: '6406' },
    { titleSelect: 'Provinsi Sulawesi Tenggara', valSelect: '6900' },
    { titleSelect: 'Kab. Buton', valSelect: '6901' },
    { titleSelect: 'Kab. Muna', valSelect: '6903' },
    { titleSelect: 'Kab. Kolaka', valSelect: '6904' },
    { titleSelect: 'Kab. Wakatobi', valSelect: '6905' },
    { titleSelect: 'Kab. Konawe', valSelect: '6906' },
    { titleSelect: 'Kab. Konawe Selatan', valSelect: '6907' },
    { titleSelect: 'Kab. Bombana', valSelect: '6908' },
    { titleSelect: 'Kab. Kolaka Utara', valSelect: '6909' },
    { titleSelect: 'Kab. Buton Utara', valSelect: '6910' },
    { titleSelect: 'Kab. Konawe Utara', valSelect: '6911' },
    { titleSelect: 'Kab. Kaloka Timur', valSelect: '6912' },
    { titleSelect: 'Kab. Konawe Kepulauan', valSelect: '6913' },
    { titleSelect: 'Kab. Buton Selatan', valSelect: '6914' },
    { titleSelect: 'Kab. Buton Tengah', valSelect: '6915' },
    { titleSelect: 'Kab. Muna Barat', valSelect: '6916' },
    { titleSelect: 'Kota Bau-Bau', valSelect: '6990' },
    { titleSelect: 'Kota Kendari', valSelect: '6991' },
    { titleSelect: 'Provinsi Nusa Tenggara Barat', valSelect: '7100' },
    { titleSelect: 'Kab. Lombok Barat', valSelect: '7101' },
    { titleSelect: 'Kab. Lombok Tengah', valSelect: '7102' },
    { titleSelect: 'Kab. Lombok Timur', valSelect: '7103' },
    { titleSelect: 'Kab. Sumbawa', valSelect: '7104' },
    { titleSelect: 'Kab. Bima', valSelect: '7105' },
    { titleSelect: 'Kab. Dompu', valSelect: '7106' },
    { titleSelect: 'Kab. Sumbawa Barat', valSelect: '7107' },
    { titleSelect: 'Kab. Lombok Utara', valSelect: '7108' },
    { titleSelect: 'Kota Mataram', valSelect: '7191' },
    { titleSelect: 'Kota Bima', valSelect: '7192' },
    { titleSelect: 'Provinsi Bali', valSelect: '7200' },
    { titleSelect: 'Kab. Buleleng', valSelect: '7201' },
    { titleSelect: 'Kab. Jembrana', valSelect: '7202' },
    { titleSelect: 'Kab. Tabanan', valSelect: '7203' },
    { titleSelect: 'Kab. Badung', valSelect: '7204' },
    { titleSelect: 'Kab. Gianyar', valSelect: '7205' },
    { titleSelect: 'Kab. Klungkung', valSelect: '7206' },
    { titleSelect: 'Kab. Bangli', valSelect: '7207' },
    { titleSelect: 'Kab. Karangasem', valSelect: '7208' },
    { titleSelect: 'Kota Denpasar', valSelect: '7291' },
    { titleSelect: 'Provinsi Nusa Tenggara Timur', valSelect: '7400' },
    { titleSelect: 'Kab. Kupang', valSelect: '7401' },
    { titleSelect: 'Kab. Timor-Tengah Selatan', valSelect: '7402' },
    { titleSelect: 'Kab. Timor-Tengah Utara', valSelect: '7403' },
    { titleSelect: 'Kab. Belu', valSelect: '7404' },
    { titleSelect: 'Kab. Alor', valSelect: '7405' },
    { titleSelect: 'Kab. Flores Timur', valSelect: '7406' },
    { titleSelect: 'Kab. Sikka', valSelect: '7407' },
    { titleSelect: 'Kab. Ende', valSelect: '7408' },
    { titleSelect: 'Kab. Ngada', valSelect: '7409' },
    { titleSelect: 'Kab. Manggarai', valSelect: '7410' },
    { titleSelect: 'Kab. Sumba Timur', valSelect: '7411' },
    { titleSelect: 'Kab. Sumba Barat', valSelect: '7412' },
    { titleSelect: 'Kab. Lembata', valSelect: '7413' },
    { titleSelect: 'Kab. Rote Ndao', valSelect: '7414' },
    { titleSelect: 'Kab. Manggarai Barat', valSelect: '7415' },
    { titleSelect: 'Kab. Sumba Tengah', valSelect: '7416' },
    { titleSelect: 'Kab. Sumba Barat Daya', valSelect: '7417' },
    { titleSelect: 'Kab. Manggarai Timur', valSelect: '7418' },
    { titleSelect: 'Kab. Nagekeo', valSelect: '7419' },
    { titleSelect: 'Kab. Sabu Raijua', valSelect: '7420' },
    { titleSelect: 'Kab. Malaka', valSelect: '7421' },
    { titleSelect: 'Kota Kupang', valSelect: '7491' },
    { titleSelect: 'Provinsi Maluku', valSelect: '8100' },
    { titleSelect: 'Kab. Maluku Tengah', valSelect: '8101' },
    { titleSelect: 'Kab. Maluku Tenggara', valSelect: '8102' },
    { titleSelect: 'Kab. Maluku Tenggara Barat', valSelect: '8103' },
    { titleSelect: 'Kab. Buru', valSelect: '8104' },
    { titleSelect: 'Kab. Seram Bagian Barat', valSelect: '8105' },
    { titleSelect: 'Kab. Seram Bagian Timur', valSelect: '8106' },
    { titleSelect: 'Kab. Kepulauan Aru', valSelect: '8107' },
    { titleSelect: 'Kab. Maluku Barat Daya', valSelect: '8108' },
    { titleSelect: 'Kab. Buru Selatan', valSelect: '8109' },
    { titleSelect: 'Kota Ambon', valSelect: '8191' },
    { titleSelect: 'Kota Tual', valSelect: '8192' },
    { titleSelect: 'Provinsi Papua', valSelect: '8200' },
    { titleSelect: 'Kab. Jayapura', valSelect: '8201' },
    { titleSelect: 'Kab. Biak Numfor', valSelect: '8202' },
    { titleSelect: 'Kab. Kepulauan Yapen-Waropen', valSelect: '8210' },
    { titleSelect: 'Kab. Merauke', valSelect: '8211' },
    { titleSelect: 'Kab. Paniai', valSelect: '8212' },
    { titleSelect: 'Kab. Jayawijaya', valSelect: '8213' },
    { titleSelect: 'Kab. Nabire', valSelect: '8214' },
    { titleSelect: 'Kab. Mimika', valSelect: '8215' },
    { titleSelect: 'Kab. Puncak Jaya', valSelect: '8216' },
    { titleSelect: 'Kab. Sarmi', valSelect: '8217' },
    { titleSelect: 'Kab. Keerom', valSelect: '8218' },
    { titleSelect: 'Kab. Pegunungan Bintang', valSelect: '8221' },
    { titleSelect: 'Kab. Yahukimo', valSelect: '8222' },
    { titleSelect: 'Kab. Tolikara', valSelect: '8223' },
    { titleSelect: 'Kab. Waropen', valSelect: '8224' },
    { titleSelect: 'Kab. Boven Digoel', valSelect: '8226' },
    { titleSelect: 'Kab. Mappi', valSelect: '8227' },
    { titleSelect: 'Kab. Asmat', valSelect: '8228' },
    { titleSelect: 'Kab. Supiori', valSelect: '8231' },
    { titleSelect: 'Kab. Mamberamo Raya', valSelect: '8232' },
    { titleSelect: 'Kab. Dogiyai', valSelect: '8233' },
    { titleSelect: 'Kab. Lanny Jaya', valSelect: '8234' },
    { titleSelect: 'Kab. Mamberamo Tengah', valSelect: '8235' },
    { titleSelect: 'Kab. Nduga', valSelect: '8236' },
    { titleSelect: 'Kab. Yalimo', valSelect: '8237' },
    { titleSelect: 'Kab. Puncak', valSelect: '8238' },
    { titleSelect: 'Kab. Intan Jaya', valSelect: '8239' },
    { titleSelect: 'Kab. Deiya', valSelect: '8240' },
    { titleSelect: 'Kota Jayapura', valSelect: '8291' },
    { titleSelect: 'Provinsi Maluku Utara', valSelect: '8300' },
    { titleSelect: 'Kab. Halmahera Tengah', valSelect: '8302' },
    { titleSelect: 'Kab. Halmahera Utara', valSelect: '8303' },
    { titleSelect: 'Kab. Halmahera Timur', valSelect: '8304' },
    { titleSelect: 'Kab. Halmahera Barat', valSelect: '8305' },
    { titleSelect: 'Kab. Halmahera Selatan', valSelect: '8306' },
    { titleSelect: 'Kab. Kepulauan Sula', valSelect: '8307' },
    { titleSelect: 'Kab. Pulau Morotai', valSelect: '8308' },
    { titleSelect: 'Kab. Pulau Taliabu', valSelect: '8309' },
    { titleSelect: 'Kota Ternate', valSelect: '8390' },
    { titleSelect: 'Kota Tidore Kepulauan', valSelect: '8391' },
    { titleSelect: 'Provinsi Papua Barat', valSelect: '8400' },
    { titleSelect: 'Kab. Sorong', valSelect: '8401' },
    { titleSelect: 'Kab. Fak-Fak', valSelect: '8402' },
    { titleSelect: 'Kab. Manokwari', valSelect: '8403' },
    { titleSelect: 'Kab. Sorong Selatan', valSelect: '8404' },
    { titleSelect: 'Kab. Raja Ampat', valSelect: '8405' },
    { titleSelect: 'Kab. Kaimana', valSelect: '8406' },
    { titleSelect: 'Kab. Teluk Bintuni', valSelect: '8407' },
    { titleSelect: 'Kab. Teluk Wondama', valSelect: '8408' },
    { titleSelect: 'Kab. Tembrauw', valSelect: '8409' },
    { titleSelect: 'Kab. Maybrat', valSelect: '8410' },
    { titleSelect: 'Kab. Pegunungan Arfak', valSelect: '8411' },
    { titleSelect: 'Kab. Manokwari Selatan', valSelect: '8412' },
    { titleSelect: 'Kota Sorong', valSelect: '8491' },
    { titleSelect: 'Di Luar Indonesia', valSelect: '9999' },
  ];

export default regionDomamin;